import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';


export const defaultState = fromJS({
    data: {},
});

export default handleActions({
    ORGANIZATIONS: {
        DATA: {
            SET: (state, { payload }) => state.set('data', fromJS(payload)),

            RESET: state => state.set('data', defaultState.get('data')),
        },
    },
}, defaultState);
